import React, { Component } from 'react';
import { Bar } from 'victory';
import { string, func, object, shape, number } from 'prop-types';

export class DeltaBar extends Component {
  render() {
    const {
      hoveredId,
      onMouseOver,
      onMouseOut,
      onClick,
      ...props
    } = this.props;

    return (
      <g>
        <Bar
          {...props}
          y={0}
          y0={props.width}
          x0={props.x0 - 8}
          style={{
            fill:
              hoveredId === props.datum.id
                ? 'rgba(224, 224, 224, 0.25)'
                : 'transparent',
            width: props.style.width + 16,
          }}
          events={{
            onMouseOver: params => onMouseOver(this.props.datum, params),
            onMouseOut: () => onMouseOut(this.props.datum),
            onClick: () => onClick(this.props.datum),
          }}
        />
        <Bar {...props} style={{ ...props.style, pointerEvents: 'none' }} />
      </g>
    );
  }
}

DeltaBar.propTypes = {
  hoveredId: string,
  onMouseOver: func.isRequired,
  onMouseOut: func.isRequired,
  style: shape({
    width: number.isRequired,
  }),
  datum: object,
};

export default DeltaBar;



// WEBPACK FOOTER //
// ./src/components/DeltaBarChart/DeltaBar.jsx